const t = {
  name: "SouthKorea",
  dimensions: { width: 18, height: 19 },
  content: `
    <g>
      <path d="M16.9998 9.32752C16.9998 7.11752 15.2198 5.33752 13.0098 5.33752C10.7998 5.33752 9.02979 7.11752 9.02979 9.32752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M1.0498 9.34753C1.0498 11.5475 2.8298 13.3375 5.0398 13.3375C7.2498 13.3375 9.0298 11.5575 9.0298 9.34753" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
      <path d="M9 17.3375C13.4183 17.3375 17 13.7558 17 9.33752C17 4.91925 13.4183 1.33752 9 1.33752C4.58172 1.33752 1 4.91925 1 9.33752C1 13.7558 4.58172 17.3375 9 17.3375Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
    </g>
  `
};
export {
  t as SouthKorea
};
